import tw from "tailwind-styled-components";
import NextImage from "../next-image/next-image";

export const ItemWrapper = tw.div`
  flex
  flex-col
  gap-2
  min-w-[213px]
  max-w-[213px]

  desktop:rounded-2xl
`;

export const Image = tw(NextImage)`
  w-full
  h-[140px]
  max-h-[140px]
  object-cover
  rounded-2xl
`;

export const DescriptionWrapper = tw.div`
`;

export const Title = tw.h3`
  text-lg
  font-bold
  text-primary-800
  desktop:font-normal
`;


export const LinkWrapper = tw.div`
  text-base
`;
